import auth0 from 'auth0-js'
import Vue from 'vue'

// exchange the object with your own from the setup step above.
let webAuth = new auth0.WebAuth({
  domain: process.env.AUTH_DOMAIN,
  clientID: process.env.CLIENT_ID,
  // make sure this line is contains the port: 8080
  redirectUri: process.env.REDIRECT_URI + '/callback',
  // we will use the api/v2/ to access the user information as payload
  audience: 'https://' + process.env.AUTH_DOMAIN + '/api/v2/',
  responseType: 'token id_token',
  scope: 'openid email profile read:users' // define the scopes you want to use
})

let auth = new Vue({
  computed: {
    token: {
      get: function () {
        return localStorage.getItem('id_token')
      },
      set: function (idToken) {
        localStorage.setItem('id_token', idToken)
      }
    },
    accessToken: {
      get: function () {
        return localStorage.getItem('access_token')
      },
      set: function (accessToken) {
        localStorage.setItem('access_token', accessToken)
      }
    },
    expiresAt: {
      get: function () {
        return localStorage.getItem('expires_at')
      },
      set: function (expiresIn) {
        let expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime())
        localStorage.setItem('expires_at', expiresAt)
      }
    },
    user: {
      get: function () {
        return JSON.parse(localStorage.getItem('user'))
      },
      set: function (user) {
        localStorage.setItem('user', JSON.stringify(user))
      }
    },
    role: {
      get: function () {
        return JSON.parse(localStorage.getItem('role'))
      },
      set: function (role) {
        localStorage.setItem('role', JSON.stringify(role))
      }
    },
    userId: {
      get: function () {
        return JSON.parse(localStorage.getItem('userId'))
      },
      set: function (userId) {
        localStorage.setItem('userId', userId)
      }
    }
  },
  methods: {
    login () {
      webAuth.authorize({
        scope: 'openid email profile read:users'
      })
    },
    logout () {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('user')
        localStorage.removeItem('userId')
        localStorage.removeItem('role')
        webAuth.logout({
          returnTo: process.env.REDIRECT_URI, // Allowed logout URL listed in dashboard
          clientID: process.env.CLIENT_ID // Your client ID
        })
      })
    },
    isAuthenticated () {
      return new Date().getTime() < this.expiresAt
    },
    handleAuthentication () {
      return new Promise((resolve, reject) => {
        webAuth.parseHash((err, authResult) => {
          if (authResult && authResult.accessToken && authResult.idToken) {
            this.expiresAt = authResult.expiresIn
            this.accessToken = authResult.accessToken
            this.token = authResult.idToken
            this.user = authResult.idTokenPayload
            console.log(authResult.idTokenPayload)
            this.role = authResult.idTokenPayload[process.env.AUTH_NAMESPACE + '/app_metadata'].role
            console.log(authResult.idTokenPayload)
            console.log(this.role)
            console.log(process.env.AUTH_NAMESPACE)
            __insp.push(['identify', this.user.email])
            resolve()
          } else if (err) {
            this.logout()
            reject(err)
          }
        })
      })
    }
  }
})

export default {
  install: function (Vue) {
    Vue.prototype.$auth = auth
  }
}



// WEBPACK FOOTER //
// ./src/auth.js